const getPermission = (ary = []) => {
  let pathname = window.location.pathname;
  while (pathname.match('/')) {
    pathname = pathname.substring(pathname.indexOf('/') + 1);
  }
  const body = {
    canAdd: ary.indexOf(`${pathname}-add`) > -1,
    canEdit: ary.indexOf(`${pathname}-edit`) > -1,
    canDel: ary.indexOf(`${pathname}-delete`) > -1,
  };
  return body;
};
const returnPermission = state => ({
  canAdd: (state.data.HandlePermission || {}).canAdd,
  canEdit: (state.data.HandlePermission || {}).canEdit,
  canDel: (state.data.HandlePermission || {}).canDel,
});
export default { getPermission, returnPermission };
